import {useEffect, useState} from "react";

const Countdown:React.FC<{time:number, logoutHandler: () => void}> = (props) => {
    const {time, logoutHandler} = props
    const [remainingTime, setRemainingTime] = useState(time);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
        const remainingTimer = setInterval(() => {
            setRemainingTime(prevState => prevState - 1);
            if(remainingTime > 0) {
                setMinutes(Math.floor(remainingTime / 60));
                setSeconds(Math.floor(remainingTime % 60));
            }else if(remainingTime <= 0) {
                clearInterval(remainingTime);
                logoutHandler();
            }
        }, 1000);
        return () => {
            clearInterval(remainingTimer);
        };
    }, [remainingTime, logoutHandler])

    return (<span>{minutes}:{(''+seconds).length < 2 ? '0' + seconds : seconds}</span>)
}

export default Countdown;